var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHouse = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M19 12a2 2 0 0 0-2 2v4h-1v2h9v-2h-1v-4a2 2 0 0 0-2-2zm3 6h-3v-4h3z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.293.293a1 1 0 0 1 1.414 0L22 5.586V4.5A1.5 1.5 0 0 1 23.5 3h5A1.5 1.5 0 0 1 30 4.5v9.086l1.707 1.707a1 1 0 0 1-1.414 1.414L30 16.414V32H15v-6a3 3 0 1 0-6 0v6H2V16.414l-.293.293a1 1 0 0 1-1.414-1.414L2 13.586V13.5h.086zM28 11.586V5h-4v2.586zM16 2.414l12 12V30H17v-4a5 5 0 0 0-10 0v4H4V14.414z",
  clipRule: "evenodd"
})));
export default SvgHouse;